import { Route, RouteObject } from "react-router-dom";
import { Landing } from "./components";
export interface DashboardSetupRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: DashboardSetupRoute[];
}
export const dashboardSetupRoutes: DashboardSetupRoute[] = [
  {
    path: "/communication-hub/dashboard",
    element: <Landing />,
  },
];
